export const CarpetasAdjuntos = {
    RequisitosAdmision: 'AdmissionRequirement',
    RequisitosGraduacion: 'GraduationRequirements',
    AnotacionesEstudiantes: 'StudentAnnotations',
    AdjuntosEstudiantes: 'StudentAttachments',
    LogoCompania: 'CompanyLogo',
    RequisitosInstitucionales: 'InstitutionalRequirements',
}

export default CarpetasAdjuntos;